module.exports = __webpack_public_path__ + "static/media/scheet_icon.94b97bb0.svg";